import Anchor from "../models/Anchor";

export default class NavigationService {
    public getNavigation(): Anchor[] {
        const anchors: Anchor[] = [];

        const htmlAnchors: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('*[data-anchor-id]');
        for (let anchor of Array.from(htmlAnchors)) {
            const anchorObject = this.buildAnchor(anchor);

            if (anchorObject.level === '1') {
                anchors.push(anchorObject)
            } else {
                const primaryIndex = anchors.length - 1;
                if (anchorObject.level === '2') {
                    anchors[primaryIndex].children.push(anchorObject);
                } else if (anchorObject.level === '3') {
                    const secondaryIndex = anchors[primaryIndex].children.length - 1;
                    anchors[primaryIndex].children[secondaryIndex].children.push(anchorObject);
                }
            }
        }
        return anchors;
    }

    private buildAnchor(anchor: HTMLElement): Anchor {
        return new Anchor({
            title: anchor.getAttribute('data-anchor-title') || '',
            level: anchor.getAttribute('data-anchor-level') || '2',
            id: anchor.getAttribute('data-anchor-id') || '',
            position: anchor.getBoundingClientRect().top + document.documentElement.scrollTop
        });
    }
}